export default "__VITE_PUBLIC_ASSET__5ef7d085__"